import { Link } from "react-router-dom";
import { getMoviesByType } from "@/utils/movieUtils";
import MovieCard from "@/components/feature/MovieCard";
import SectionHeading from "@/components/feature/SectionHeading";

interface ShowcaseSectionProps {
  type: "movie" | "series";
  title: string;
  subtitle: string;
  icon: string;
  limit?: number;
}

export default function ShowcaseSection({
  type,
  title,
  subtitle,
  icon,
  limit = 4,
}: ShowcaseSectionProps) {
  const list = getMoviesByType(type)
    .sort((a, b) => b.popularity - a.popularity)
    .slice(0, limit);

  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-8 md:px-8 md:py-10">
      <SectionHeading
        title={title}
        subtitle={subtitle}
        icon={icon}
        action={
          <Link
            to={`/category/${type}`}
            className="hidden items-center gap-1 text-sm font-medium text-primary-600 transition-colors hover:text-primary-700 sm:flex whitespace-nowrap"
          >
            全部{type === "movie" ? "电影" : "电视剧"}
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        }
      />
      <div className="grid grid-cols-2 gap-3 md:gap-5 sm:grid-cols-3 lg:grid-cols-4">
        {list.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}